import './GiftSelections.scss'

import React, {useState} from 'react'
import {WysiwygType} from '../../types'
import {style} from '../../util/style'
import {formatNumber} from '../pages'
import {Theme} from '../Theme'

const styles = style('giftselections', ['item', 'custom'])

export type GiftSelectionsType = {
	className?: string
	items: Array<GiftSelectionsItemType>
	showDesc?: boolean
	showCustom?: boolean
	onChangeHandler: (price: number) => void
}

type GiftSelectionsItemType = {
	price: number
	description?: WysiwygType
	show_information?: boolean
	information?: WysiwygType
}

export const GiftSelections: React.FC<GiftSelectionsType> = ({
	className,
	items,
	showDesc,
	showCustom,
	onChangeHandler
}) => {
	if (!items || items.length === 0) return null
	const [price, setPrice] = useState<number | null>(null)

	return (
		<div className={styles().with(className)}>
			<div className={styles('items').mod({desc: showDesc})}>
				{items.map((item) => (
					<GiftSelectionsItem
						key={item.price}
						selected={price === item.price}
						onClick={() => {
							setPrice(item.price)
							onChangeHandler(item.price)
						}}
						showDesc={showDesc}
						{...item}
					/>
				))}
				{showCustom && (
					<GiftSelectionsCustom
						price={price}
						onChangeHandler={(newPrice: number) => {
							setPrice(newPrice)
							onChangeHandler(newPrice)
						}}
						showDesc={showDesc}
					/>
				)}
			</div>
		</div>
	)
}

const GiftSelectionsItem: React.FC<
	GiftSelectionsItemType & {
		selected: boolean
		onClick: () => void
		showDesc?: boolean
	}
> = ({
	selected,
	onClick,
	price,
	description,
	show_information,
	information,
	showDesc
}) => {
	if (!price) return null

	return (
		<div className={styles.item()}>
			<a onClick={onClick} className={styles.item('block').is({selected})}>
				€{price}
				{show_information && information && (
					<div className={styles.item('block-tooltip')}>
						<span className={styles.item('block-tooltip-toggle')}>i</span>
						<div className={styles.item('block-tooltip-content')}>
							<Theme.Wysiwyg>{information}</Theme.Wysiwyg>
						</div>
					</div>
				)}
			</a>
			{showDesc && description && (
				<div className={styles.item('description')}>
					<Theme.Wysiwyg>{description}</Theme.Wysiwyg>
				</div>
			)}
		</div>
	)
}

const GiftSelectionsCustom: React.FC<{
	price: number | null
	onChangeHandler: (newPrice: number) => void
	showDesc?: boolean
}> = ({price, onChangeHandler, showDesc}) => {
	return (
		<div className={styles.custom().mod({desc: showDesc})}>
			<input
				type="text"
				placeholder="?"
				onChange={(e) => {
					const value: number = formatNumber(
						(e.target.value as unknown) as string
					)
					onChangeHandler(value ? value : 0)
				}}
				value={price && `€${price}`}
				className={styles.custom('input')}
			/>
		</div>
	)
}
